import { motion } from 'framer-motion';
import './index.less'
const Loader = ({children, time} : any) => {
  const duration = time || 1
  return (
    <motion.div
      className='loader-spin-box'
      animate={{ rotate: 360 }}
      transition={{
        duration: duration,
        ease: "linear",
        repeat: Infinity,
        delay: 0
      }}
    >{ children }</motion.div>
  );
};

export default Loader;
